import React from 'react'
import AdminUserManagement from './AdminUserManagement/AdminUserManagement'
import AdminVPNConnection from './AdminVPNConnection/AdminVPNConnection'
import AdminSubscription from './AdminSubscription/AdminSubscription'
import AdminSiteContent from './AdminSiteContent/AdminSiteContent'

export default function AdminDashboardPages() {
  return (
<section className='AdminDashboardPages'>
  <AdminUserManagement/>
  {/* <AdminVPNConnection/> */}
  <AdminSubscription/>
  <AdminSiteContent/>
  
</section>
  )
}
